import React, { useState, useEffect } from 'react';
import { Platform } from 'react-native';
import { Image, ImageBackground, View } from 'react-native';
import Config from '../../constants/Config';
import { useRoute } from '@react-navigation/native';
import useMounted from '../../hooks/useMounted';

const ModelBackgroundImage = ({ model, style, resizeMode, localPath }) => {
    const route = useRoute();
    const isMounted = useMounted();
    const [image, setImage] = useState(null)

    useEffect(() => {
        if (model?.upload?.path) {
            let path = model?.upload?.path
            let fullPath = `${!localPath ? Config.uploadUrl : ''}${path}`
            Image.prefetch(fullPath)
            try {
                if (Platform.OS !== 'web') {
                    isMounted.current && Image.getSizeWithHeaders(fullPath, {}, (width, height) => {
                        isMounted.current && setImage({
                            uri: fullPath,
                            width,
                            height
                        })
                    }, error => {
                        //
                        console.log(error)
                    })
                } else {
                    isMounted.current && Image.getSize(
                        fullPath,
                        (width, height) => {
                            isMounted.current && setImage({
                                uri: fullPath,
                                width,
                                height
                            })
                        },
                        error => {
                            console.log(error)
                        }
                    )
                }
            } catch (e) {
                console.log(e)
                isMounted.current && setImage({
                    uri: fullPath
                })
            }
        }
        return () => { }
    }, [model])


    return <>
        {
            image?.uri
                ? Platform.OS === 'android'
                    ? <ImageBackground
                        source={{ uri: image.uri }}
                        style={[
                            {
                                width: '100%',
                                height: undefined,
                                // aspectRatio: image.width / image.height,
                            },
                            style
                        ]}
                        resizeMode={resizeMode || "contain"}
                    ></ImageBackground>
                    : <View
                        style={[
                            style,
                            {
                                justifyContent: 'center'
                            }
                        ]}
                    >
                        <Image
                            source={{ uri: image.uri }}
                            style={[
                                resizeMode === 'cover' && {
                                    minWidth: '100%',
                                    minHeight: '100%'
                                },
                                resizeMode === 'contain' && {
                                    alignSelf: 'center',
                                    width: image?.width > image?.height ? '100%' : image.width / image.height * 100 + '%',
                                    height: image?.width > image?.height ? image.height / image.width * 100 + '%' : '100%',
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    aspectRatio: image.width / image.height
                                }
                            ]}
                        />
                    </View>
                : null
        }
    </>
}

export default ModelBackgroundImage